import React, {Component, Fragment} from "react";
import ListView from "./ListView";
import EditView from "./EditView";

export default class Users extends Component {
    constructor(props) {
        super(props);

        let formid = props.formid;
        let formname = props.formname || process.env.REACT_APP_USER_FORMNAME;
        let action = props.action;

        this.state = {
            formname : formname,
            formid : formid,
            action : action,
        };
    }

    render() {

        let {action, formname, formid} = this.state;

        if(action === "new" || action === "edit"){
            return (
                <Fragment>
                    <EditView formname={formname} formid={formid} action={action}/>
                </Fragment>
            );
        }else{
            let settingsAction = "/account/users";

            return (
                <Fragment>
                    <ListView formname={formname} settingsAction={settingsAction}/>
                </Fragment>
            );
        }
    }
}